import React from 'react';
import { Tag } from 'rsuite';
import {
  EnergyHubClubVisitStatus, EnergyHubClubVisitStatusList, EnergyHubReceiptStatus, EnergyHubReceiptStatusList,
  EnergyHubStatus, EnergyHubStatusList,
} from '@/models/energy-hub.model';

const hubColor: Record<number, string> = {
  [EnergyHubStatus.Draft]: 'orange',
  [EnergyHubStatus.Active]: 'green',
  [EnergyHubStatus.Paused]: 'yellow',
  [EnergyHubStatus.Closed]: 'red',
};

export const EnergyHubStatusTag: React.FC<{ status: EnergyHubStatus }> = ({ status }) => (
  <Tag color={hubColor[status] as any}>{EnergyHubStatusList.find(s => s.value == status)?.label ?? status}</Tag>
);

const clubVisitColor: Record<number, string> = {
  [EnergyHubClubVisitStatus.Requested]: 'orange',
  [EnergyHubClubVisitStatus.Approved]: 'green',
  [EnergyHubClubVisitStatus.Rejected]: 'red',
  [EnergyHubClubVisitStatus.Cancelled]: 'violet',
};

export const EnergyHubClubVisitStatusTag: React.FC<{ status: EnergyHubClubVisitStatus }> = ({ status }) => (
  <Tag color={clubVisitColor[status] as any}>{EnergyHubClubVisitStatusList.find(s => s.value == status)?.label ?? status}</Tag>
);

const receiptColor: Record<number, string> = {
  [EnergyHubReceiptStatus.Pending]: 'orange',
  [EnergyHubReceiptStatus.Approved]: 'green',
  [EnergyHubReceiptStatus.Rejected]: 'red',
};

export const EnergyHubReceiptStatusTag: React.FC<{ status: EnergyHubReceiptStatus }> = ({ status }) => (
  <Tag color={receiptColor[status] as any}>{EnergyHubReceiptStatusList.find(s => s.value == status)?.label ?? status}</Tag>
);

export default EnergyHubStatusTag;
